export class LoginModel {
    userType: number;

    DomainTypeId: number;
    UserEmail: string;
    UserName: string;
    OTP: string;
    Password: string;

    constructor() {
        this.userType = 3;
        this.DomainTypeId = 1;
        this.UserEmail = '';
        this.UserName = '';
        this.OTP = '';
        this.Password = '';
    }
}